import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import validator from 'validator';

import MuiTextField from '@material-ui/core/TextField';
import MuiButton from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiSelect from '@material-ui/core/Select';
import MuiMenuItem from '@material-ui/core/MenuItem';
import MuiFormControl from '@material-ui/core/FormControl';
import MuiInputLabel from '@material-ui/core/InputLabel';

import { LABEL_ROLES } from 'utils/constants';

import * as API from 'api';
import { useMutation } from 'react-query';
import { sanitizeFormatCharacters } from 'utils/format';

const Groups = API.Groups();

const styles = theme => ({
  formRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '4px',
    marginBottom: '10px',
  },
  formControl: {
    width: '100%',
  },
  dialogFooter: {
    padding: theme.spacing(1.5),
  },
});

const DialogInviteUser = ({ open, onClose, onCreated, group, ...props }) => {
  const { classes } = props;

  const [email, setEmail] = useState('');
  const [role, setRole] = useState('');

  const inviteGroupUserMutation = useMutation(({ groupId, email, role }) => Groups.inviteUser(groupId, email, role), {
    onSuccess: () => {
      onCreated(group?.id);
      setError(null);
      setEmail('');
      setRole('');
    },
    onError: error => {
      const errorMsg = error.data.detail;
      setError(errorMsg);
      alert(errorMsg);
    },
  });

  const [error, setError] = useState(null);

  const handleFormSubmit = async () => {
    if (!validator.isEmail(email)) {
      setError('invalid email address');
      return;
    }
    if (!role) {
      setError('invalid role');
      return;
    }
    await inviteGroupUserMutation.mutateAsync({ groupId: group.id, email: sanitizeFormatCharacters(email), role });
  };

  return (
    <MuiDialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
      <MuiDialogTitle id="form-dialog-title">Invite New User</MuiDialogTitle>
      <MuiDialogContent>
        <div className={classes.formRow}>
          <MuiFormControl label="Group">
            <MuiSelect disabled variant="outlined" defaultValue={group?.id}>
              <MuiMenuItem key={group?.id} value={group?.id}>
                {group?.name}
              </MuiMenuItem>
            </MuiSelect>
          </MuiFormControl>
        </div>
        <div className={classes.formRow}>
          <MuiTextField
            value={email}
            onChange={e => setEmail(e.target.value)}
            label="Email Address"
            type="email"
            variant="outlined"
            className={classes.formControl}
          />
        </div>
        <div className={classes.formRow}>
          <MuiFormControl variant="outlined" className={classes.formControl} name="role">
            <MuiInputLabel>Role</MuiInputLabel>
            <MuiSelect label="Role" variant="outlined" value={role} onChange={e => setRole(e.target.value)}>
              <MuiMenuItem value={LABEL_ROLES.get('admin')}>Label Admin</MuiMenuItem>
              <MuiMenuItem value={LABEL_ROLES.get('member')}>Label Member</MuiMenuItem>
            </MuiSelect>
          </MuiFormControl>
        </div>
        {error && <div>{error}</div>}
      </MuiDialogContent>
      <MuiDialogActions className={classes.dialogFooter}>
        <MuiButton variant="contained" onClick={onClose}>
          Cancel
        </MuiButton>
        <MuiButton variant="contained" color="primary" type="submit" onClick={handleFormSubmit}>
          Create
        </MuiButton>
      </MuiDialogActions>
    </MuiDialog>
  );
};

export default withStyles(styles)(DialogInviteUser);
